import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "phone-number-input mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "form-label"
}
const _hoisted_3 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, watch } from 'vue';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css'; // Correct path

export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumber',
  props: {
  modelValue: {
    type: String,
    default: '',
  },
  label: String,
  placeholder: {
    type: String,
    default: 'Enter phone number',
  },
  disabled: Boolean,
  readonly: Boolean,
  v: {
    type: Object,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const phoneNumber = ref(props.modelValue);
const errorMessage = ref('');
const emits = __emit;

// Triggered whenever the user types or the country changes
const handleInput = (formattedNumber: string, phoneObject: any) => {
  // If you want to store the clean E.164 international format (e.g., "+12015550123")
  const valueToEmit = phoneObject?.number || formattedNumber;

  // Alternatively, if you only want pure numbers without "+", uncomment below:
  // const valueToEmit = (phoneObject?.number || formattedNumber).replace(/\D/g, '');

  emits('update:modelValue', valueToEmit ?? '');
};

watch(() => props.modelValue, (newValue) => {
  phoneNumber.value = newValue;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("b", _hoisted_2, _toDisplayString(__props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_unref(VueTelInput), {
      modelValue: phoneNumber.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
      disabled: __props.disabled,
      readonly: __props.readonly,
      "input-options": {
      placeholder: __props.label,
      disabled: __props.disabled,
      readonly: __props.readonly,
      styleClasses: 'form-control'
    },
      "dropdown-options": {
      showDialCodeInSelection: true,
      showFlags: true,
      showSearchBox: true,               
      searchBoxPlaceholder: 'Recherche...'  
    },
      onOnInput: handleInput
    }, null, 8, ["modelValue", "disabled", "readonly", "input-options"]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "text-danger",
        key: error.$uid
      }, [
        _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
        _hoisted_4
      ]))
    }), 128))
  ]))
}
}

})